<template>
  <div>
    <canvas
      :id="`canvas_${canvasKey}`"
      :ref="`canvas_${canvasKey}`"
      :width="canvasWidth"
      :height="size.long / this.drawScale + 88"
    ></canvas>
  </div>
</template>

<script>
import { toDecimal } from '@/util/commonFuncs.js'
import { closePath } from '@/util/plankCommonFuncs'

import { dealSupplusPoints } from '../../util/dealSupplusPoints.js'

export default {
  props: {
    canvasKey: {
      type: [String, Boolean],
    },
    size: {
      type: Object,
      default: () => {},
    },
    drawScale: {
      type: Number,
      default: 1,
    },
    isNewSurplus: {
      type: Boolean,
      default: false,
    },
    defaultRectText: {
      type: String,
      default: '板件',
    },
    isDrawSize: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      canvas: {},
    }
  },
  watch: {
    canvasKey() {
      this.$nextTick(() => {
        this.canvas.clearRect(0, 0, 400, 400)
        this.draw()
      })
    },
  },
  computed: {
    canvasWidth() {
      let width = this.size.width / this.drawScale + 120
      if (['L', '1'].includes(this.canvasKey)) {
        width += 50
      }
      if (!this.canvasKey) {
        if (this.size.min_long != 0) {
          width += 50
        }
      }
      return this.defaultRectText ? width + 10 : width
    },
  },
  methods: {
    draw() {
      let dom = this.$refs[`canvas_${this.canvasKey}`]
      let ctx = dom.getContext('2d')
      this.canvas = ctx
      ctx.fillStyle = '#ECCEA0'
      ctx.strokeStyle = '#CCCCCC'
      ctx.font = `12px "PingFangSC-Regular, PingFang SC"`

      if (['rect', '0'].includes(this.canvasKey)) {
        let obj = dealSupplusPoints(
          this.isDrawSize ? false : this.defaultRectText,
          this.size,
          this.drawScale
        )
        this.drawRect(ctx, obj)
      } else if (
        ['L', '1'].includes(this.canvasKey) &&
        (!this.size.path || !this.size.path.length)
      ) {
        let obj = dealSupplusPoints(
          this.isDrawSize ? false : 'L',
          this.size,
          this.drawScale
        )
        this.drawLShape(ctx, obj)
      } else if (
        ['specialShape', '2'].includes(this.canvasKey) &&
        this.size.path &&
        this.size.path.length
      ) {
        const sizePath = this.size.path
        const firstPoint = this.size.path[0]
        const lastPoint = this.size.path[this.size.path.length - 1]
        if (firstPoint.x !== lastPoint.x || firstPoint.y !== lastPoint.y) {
          sizePath.push(firstPoint)
        }
        let obj = {
          path: sizePath.map((item) => {
            return {
              x: item.x / this.drawScale,
              y: item.y / this.drawScale,
            }
          }),
        }
        // dealSupplusPoints('specialShape', this.size, this.drawScale)
        this.drawSpecialShape(ctx, obj)
      }
      //  else if (this.canvasKey == 'C') {
      //   // TODO 绘制C型
      //   let obj = dealSupplusPoints('C', this.size, this.drawScale)
      //   this.drawCShape(ctx, obj)
      // }
      else {
        if (!this.size.path || !this.size.path.length) {
          if (this.size.min_long == 0) {
            let obj = dealSupplusPoints(false, this.size, this.drawScale)
            this.drawRect(ctx, obj)
          } else {
            let obj = dealSupplusPoints(false, this.size, this.drawScale)
            this.drawLShape(ctx, obj)
          }
        } else {
          const sizePath = closePath(this.size.path)
          let obj = {
            path: sizePath.map((item) => {
              return {
                x: item.x / this.drawScale,
                y: item.y / this.drawScale,
              }
            }),
          }
          this.drawSpecialShape(ctx, obj)
        }
      }
    },
    // 绘制矩形余料
    drawRect(ctx, obj) {
      ctx.beginPath()
      for (let i = 0; i < obj.shape.length; ++i) {
        let point = obj.shape[i]
        if (i == 0) {
          ctx.moveTo(point.x + 30, point.y + 30)
        } else {
          ctx.lineTo(point.x + 30, point.y + 30)
        }
      }
      ctx.closePath()
      ctx.fill()

      // 绘制标尺线
      ctx.beginPath()
      ctx.fillStyle = '#333'
      for (let i = 0; i < obj.plankW.line.length; ++i) {
        let point = obj.plankW.line[i]
        if (i % 2 == 0) {
          ctx.moveTo(
            point.x + 30,
            point.y + this.size.long / this.drawScale + 42
          )
        } else {
          ctx.lineTo(
            point.x + 30,
            point.y + this.size.long / this.drawScale + 42
          )
        }
      }
      ctx.fillText(
        obj.plankW.text.str,
        obj.plankW.text.x + 30,
        obj.plankW.text.y + 65 + this.size.long / this.drawScale
      )
      for (let i = 0; i < obj.plankH.line.length; ++i) {
        let point = obj.plankH.line[i]
        if (i % 2 == 0) {
          ctx.moveTo(
            point.x + this.size.width / this.drawScale + 42,
            point.y + 30
          )
        } else {
          ctx.lineTo(
            point.x + this.size.width / this.drawScale + 42,
            point.y + 30
          )
        }
      }
      ctx.fillText(
        obj.plankH.text.str,
        obj.plankH.text.x + this.size.width / this.drawScale + 55,
        obj.plankH.text.y + 30
      )
      ctx.stroke()
    },
    // 绘制L形余料
    drawLShape(ctx, obj) {
      ctx.beginPath()
      let extraOffset = 35
      for (let i = 0; i < obj.shape.length; ++i) {
        let point = obj.shape[i]
        if (i == 0) {
          ctx.moveTo(point.x + 50 + extraOffset, point.y + 50)
        } else {
          ctx.lineTo(point.x + 50 + extraOffset, point.y + 50)
        }
      }
      ctx.closePath()
      ctx.fill()

      // 绘制标尺线
      // 板件宽度
      ctx.beginPath()
      ctx.fillStyle = '#333'
      for (let i = 0; i < obj.plankW.line.length; ++i) {
        let point = obj.plankW.line[i]
        if (i % 2 == 0) {
          ctx.moveTo(
            point.x + 50 + extraOffset,
            point.y + this.size.long / this.drawScale + 62
          )
        } else {
          ctx.lineTo(
            point.x + 50 + extraOffset,
            point.y + this.size.long / this.drawScale + 62
          )
        }
      }
      ctx.fillText(
        obj.plankW.text.str,
        obj.plankW.text.x + 50 + extraOffset,
        obj.plankW.text.y + 85 + this.size.long / this.drawScale
      )

      // 板件长度
      for (let i = 0; i < obj.plankH.line.length; ++i) {
        let point = obj.plankH.line[i]
        if (i % 2 == 0) {
          ctx.moveTo(point.x + 20 + extraOffset, point.y + 51)
        } else {
          ctx.lineTo(point.x + 20 + extraOffset, point.y + 51)
        }
      }
      ctx.fillText(
        obj.plankH.text.str,
        obj.plankH.text.x,
        obj.plankH.text.y + 50
      )

      // 板件短边宽度
      for (let i = 0; i < obj.plankMinW?.line.length; ++i) {
        let point = obj.plankMinW.line[i]
        if (i % 2 == 0) {
          ctx.moveTo(point.x + 50 + extraOffset, point.y + 20)
        } else {
          ctx.lineTo(point.x + 50 + extraOffset, point.y + 20)
        }
      }
      ctx.fillText(
        obj.plankMinW?.text.str,
        obj.plankMinW?.text.x + 50 + extraOffset,
        obj.plankMinW?.text.y + 20
      )

      // 板件短边长度
      for (let i = 0; i < obj.plankMinH?.line.length; ++i) {
        let point = obj.plankMinH.line[i]
        if (i % 2 == 0) {
          ctx.moveTo(
            point.x + this.size.width / this.drawScale + 60 + extraOffset,
            point.y +
              (this.size.long - this.size.min_long) / this.drawScale +
              50
          )
        } else {
          ctx.lineTo(
            point.x + this.size.width / this.drawScale + 60 + extraOffset,
            point.y +
              (this.size.long - this.size.min_long) / this.drawScale +
              50
          )
        }
      }
      ctx.fillText(
        obj.plankMinH?.text.str,
        obj.plankMinH?.text.x +
          this.size.width / this.drawScale +
          80 +
          extraOffset,
        obj.plankMinH?.text.y +
          (this.size.long - this.size.min_long) / this.drawScale +
          51
      )

      ctx.stroke()
    },
    drawSpecialShape(ctx, obj) {
      ctx.beginPath()
      const offset = 50
      const sizePath = closePath(this.size.path)
      const path = obj.path
      closePath(path)
      const drawPath = path.map((point) => {
        return {
          x: (point.x * 1000 + offset * 1000) / 1000,
          y: (point.y * 1000 + offset * 1000) / 1000,
        }
      })
      for (let i = 0; i < drawPath.length; ++i) {
        let point = drawPath[i]
        if (i == 0) {
          ctx.moveTo(point.x, point.y)
        } else {
          ctx.lineTo(point.x, point.y)
        }
      }
      ctx.closePath()
      ctx.fill()
      ctx.stroke()
      ctx.fillStyle = '#333'

      ctx.beginPath()

      for (let i = 0; i < drawPath.length; i++) {
        const point = drawPath[i]
        const x = toDecimal(point.x, 1)
        const y = toDecimal(point.y, 1)

        if (i > 0) {
          // 绘制路径时，绘制长度标记
          /** 上一个点位 */
          const lastPoint = drawPath[i - 1]
          const lastPointReal = sizePath[i - 1]
          const currentPointReal = sizePath[i]
          /** 绘制点位 */
          const lastX = toDecimal(lastPoint.x, 1)
          const lastY = toDecimal(lastPoint.y, 1)
          /** 实际点位 */
          const lastXReal = toDecimal(lastPointReal.x, 1)
          const lastYReal = toDecimal(lastPointReal.y, 1)
          const currentXReal = toDecimal(currentPointReal.x, 1)
          const currentYReal = toDecimal(currentPointReal.y, 1)

          // 如果是竖线
          if (Math.abs(lastXReal - currentXReal) <= 0.01) {
            /** 计算两点之间的距离 */
            const distance =
              Math.abs(currentYReal * 1000 - lastYReal * 1000) / 1000
            const textStartX = point.x
            /** 计算文本的起点Y坐标 */
            const textStartY =
              Math.max(y, lastY) - distance / this.drawScale / 2
            ctx.fillText(Number(distance.toFixed(2)), textStartX, textStartY)
          } else {
            const distance =
              Math.abs(currentXReal * 1000 - lastXReal * 1000) / 1000
            const textStartX =
              Math.max(x, lastX) - distance / this.drawScale / 2
            const textStartY = y
            ctx.fillText(Number(distance.toFixed(2)), textStartX, textStartY)
          }
        }
      }
    },
    // TODO 绘制C形余料
    drawCShape(ctx, obj) {},
  },
  mounted() {
    this.draw()
  },
}
</script>

<style scoped></style>
